import env from "../../libs/tools/Environment";

export default {
  props: {},
  data() {
    return {
      agree: false,
      urls: null,
    };
  },
  computed: {
    currentLang() {
      return env.getLang();
    },
    isShowTerms() {
      return this.$store.getters["terms/isOutdated"];
    },
    getUrls() {
      return this.$store.getters["terms/getUrls"];
    },
    buildLinksList() {
      if (!this.getUrls) return "";
      let lang = this.$i18n && this.$i18n.locale ? this.$i18n.locale : this.currentLang;
      return this.getUrls
        .reduce((res, item) => {
          if (!item[lang]) {
            return res;
          }
          return res + `, <a href="${item.url}" target="_blank">${item[lang]}</a>`;
        }, "")
        .substring(2);
    },
  },

  methods: {
    acceptTerms() {
      this.$store.dispatch("terms/acceptTerms");
    },
    getTermsInfo(force_run = false) {
      return this.$store.dispatch("terms/getTermsInfo", force_run);
    },
  },
};
